import React, { useState } from 'react';
import VisualAttackInterface from '../../components/VisualAttackInterface';
import DynamicOrchestratorMonitor from '../../components/DynamicOrchestratorMonitor';
import AttackBuilder from '../../components/AttackBuilder';
import { Zap, Network, ChevronDown, ChevronUp, Hammer } from 'lucide-react';
import { AttackWelcomeBanner } from '../../components/WelcomeBanner';
import PlanRestrictedPage from '../../components/PlanRestrictedPage';
import { useI18n } from '../../i18n';

/**
 * Attack Page - Interface Visuelle d'Attaque avec thème ROUGE
 *
 * Cette page présente:
 * - Dynamic Pentest Orchestrator (parallélisme intelligent)
 * - Graphe d'attaque interactif (ReactFlow)
 * - Panel AI Coach en temps réel
 * - Console terminal avec coloration syntaxique
 * - Wizards pour outils de sécurité (SQLMap, Nmap, Metasploit, Hydra)
 * - Mode simulation avant exécution réelle
 */
const AttackPage = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState('orchestrator');
  const [orchestratorExpanded, setOrchestratorExpanded] = useState(true);

  return (
    <PlanRestrictedPage
      feature="advanced_tools"
      title={t('attack.title')}
      description={t('attack.description')}
      icon={Zap}
    >
    <main className="flex-1 w-[95%] sm:w-[92%] lg:w-[88%] laptop:w-[85%] 2xl:w-[80%] max-w-[1600px] laptop:max-w-[1700px] 2xl:max-w-[1800px] mx-auto px-6 py-8">
      {/* Welcome Banner */}
      <AttackWelcomeBanner />

      {/* Tabs de navigation */}
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => setActiveTab('orchestrator')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
            activeTab === 'orchestrator'
              ? 'bg-red-600 text-white shadow-lg shadow-red-600/30'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
          }`}
        >
          <Zap className="w-4 h-4" />
          <span>{t('attack.dynamicOrchestrator')}</span>
        </button>
        <button
          onClick={() => setActiveTab('visual')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
            activeTab === 'visual'
              ? 'bg-red-600 text-white shadow-lg shadow-red-600/30'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
          }`}
        >
          <Network className="w-4 h-4" />
          <span>{t('attack.attackGraph')}</span>
        </button>
        <button
          onClick={() => setActiveTab('builder')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
            activeTab === 'builder'
              ? 'bg-red-600 text-white shadow-lg shadow-red-600/30'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
          }`}
        >
          <Hammer className="w-4 h-4" />
          <span>{t('attack.attackBuilder')}</span>
        </button>
      </div>

      {/* Contenu selon l'onglet actif */}
      {activeTab === 'orchestrator' && (
        <div className="space-y-6">
          <DynamicOrchestratorMonitor
            onPentestStart={(result) => {
              console.log('Pentest started:', result);
            }}
            onPentestComplete={() => {
              console.log('Pentest completed');
            }}
          />
        </div>
      )}

      {activeTab === 'visual' && (
        <VisualAttackInterface />
      )}

      {activeTab === 'builder' && (
        <AttackBuilder />
      )}
    </main>
    </PlanRestrictedPage>
  );
};

export default AttackPage;
